import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useLms } from '../../context/LmsContext';
import { defaultDashboard } from '../../utils/navigation';

export default function Unauthorized() {
  const { currentUser } = useLms();
  return (
    <div className="center-page">
      <ShieldAlert size={58} />
      <h1>Unauthorized</h1>
      <p>You do not have permission to open this route. The app protects pages based on the active account role.</p>
      <Link className="button button-primary" to={defaultDashboard(currentUser?.role)}>Go back to dashboard</Link>
    </div>
  );
}
